// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 检查最新版本 GET /software-package/check */
export async function softwarePackageCheckUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.softwarePackageCheckUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultSoftwarePackageVersionInfoResp>('/software-package/check', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取最新安装包 GET /software-package/latest */
export async function softwarePackageLatestUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.softwarePackageLatestUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultSoftwarePackageResp>('/software-package/latest', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
